import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {useMyOan} from '../../../api/hooks/useMyOan.hook';
import {fetchMyOanInstances, useAppSelector} from '../../../redux';
import {BasicCardVariants} from '../../../utils/_enums/basic-card-variants.enum';
import {TypographyVariantsEnum} from '../../../utils/_enums/typeography-variants.enum';
import {mapStrapiHeadline} from '../../../utils/_helper/strapi-mapper';
import useBreakpoint from '../../../utils/_hooks/useBreakpoints.hook';
import {Spacer} from '../../_shared/spacer/spacer';
import Teaser from '../../_shared/teaser/teaser';
import TeaserCard from '../../_shared/teaser-card/teaser-card';
import TextSection from '../../_shared/text-section/text-section';
import {Typography} from '../../_shared/typography/typography';
import styles from './my-oan-teaser.module.scss';

const MyOanTeaser = (): JSX.Element => {
    const data = useMyOan();
    const breakpoint = useBreakpoint();
    const dispatch = useDispatch();
    const {myOanId, instances, user, walletId, addToBasketModelPending, addToBasketStatus} = useAppSelector(
        (state) => ({
            instances: state.productSlice.myOanInstances,
            myOanId: state.myOanSlice.user?.id,
            user: state.userSlice.user,
            walletId: state.blockchainSlice.walletId,
            addToBasketModelPending: state.checkoutSlice.pending,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus
        }));

    useEffect(() => {
        if (myOanId) {
            dispatch(fetchMyOanInstances(myOanId));
        }
    }, []);

    if (!myOanId || instances?.fulfilled && instances?.data.length === 0) {
        return (
            <div className={styles['my-oan-teaser-wrapper']}>
                {breakpoint !== 'mobile' && (
                    <Spacer height='50px'/>
                )}
                <Typography className={data?.noNftNote?.title?.cssClass ?? ''}
                            element={data?.noNftNote?.title?.element ?? ''}
                            variant={mapStrapiHeadline(data?.noNftNote?.title?.style)}
                            style={{
                                textAlign: (data?.noNftNote?.title?.textAlign?.toLowerCase?.() as
                                    | 'left'
                                    | 'right'
                                    | 'center'
                                    | 'justify'
                                    | undefined) ?? 'left'
                            }}>
                    {data?.noNftNote?.title?.headlineContent}
                </Typography>
                <TextSection description={data?.noNftNote?.description?.content ?? ''}/>
            </div>
        );
    } else {
        if (instances?.data && instances.data.length > 0) {
            return (
                <div className={styles['my-oan-teaser-wrapper']}>
                    <Teaser
                        headline={
                            data
                                ? data.ownedItemsHeadline.headlineContent
                                : ''
                        }
                        hideTeaserButtons={true}
                        maxCards={instances.maxNumber}
                        headlineElement={'h2'}
                        headlineVariant={TypographyVariantsEnum.HEADING1}
                        withNumbers={true}
                        pending={instances.pending}
                        pagination={instances.pagination}
                        cards={instances.data.slice(0).map((instance) => (
                            <TeaserCard key={`my-oan-instance-${instance.id}`} instance={instance}/>
                        ))}
                        onLoadNewItems={() => undefined}
                        type={BasicCardVariants.BASIC_CARD_SMALL}
                    />
                </div>
            );
        } else {
            return <div/>;
        }
    }
}

export default MyOanTeaser;
